import React, { PropTypes } from 'react';
import Dropzone from 'react-dropzone';
import { byteToMegabyte } from '../helpers/helpers';
import _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';

const timezone = 'America/New_York';

const AssignmentFileSubmission = (props) => {
    let dropzone_ref;

    let isUploaded = function (filename) {
        for (let i = 0, l = props.assignment.assignment_files.length; i < l; i++) {
            let assignment_file = props.assignment.assignment_files[i];
            if (assignment_file.name === filename &&
                (
                    assignment_file.progress === undefined ||
                    assignment_file.progress === 100
                )
            ) {
                  return true;
            }
        }
        return false;
    };

    let getAssignmentFile = function (filename) {
        const { assignment } = props,
            { assignment_files } = assignment
        ;

        if (assignment_files) {
            for (let i = 0, l = props.assignment.assignment_files.length; i < l; i++) {
                let assignment_file = props.assignment.assignment_files[i];
                if (assignment_file.name === filename) {
                    return assignment_file;
                }
            }
        }

        return undefined;
    };

    let assignment_filename = function (assignment_filename, i) {
        let file = getAssignmentFile(assignment_filename);
        return (
            <div id={"assignment_files" + i} className="uploaded-file mb-2" key={"file_" + assignment_filename}>
                {
                    file
                    ? (
                        [file].map(assignment_file)
                    ) : (
                        <div key={'assignment_file_' + assignment_file.id + '_label'}>
                            {assignment_filename}
                            <span className="progress">
                                <div key=
                                    {'assignment_file_' + assignment_file.id}
                                    className="progress-bar"
                                    style={{width:'0%'}}
                                    role="progressbar"
                                />
                            </span>
                        </div>
                    )
                }
            </div>
        );
    };

    let assignment_file = function(assignment_file, i) {
        let prefix = 'assignment_file_';
        return (
            isUploaded(assignment_file.name) === true
            ? (
                <div key={assignment_file.id} className={props.disabled ? 'disabled-overlay' : null}>
                    <button
                        className="btn-link download-file"
                        key={assignment_file.id + "_download"}
                        id={assignment_file.id}
                        name={assignment_file.name}
                        size={assignment_file.size}
                        onClick={props.onDownloadFile}
                        disabled={props.disabled}
                    >
                        <i
                            className="fa fa-download"
                            aria-hidden="true" id={assignment_file.id}
                            name={assignment_file.name}
                        /> {assignment_file.name}
                    </button>
                    <span> - {byteToMegabyte(assignment_file.size)}</span>
                    <div className="float-right">
                        {
                            moment(assignment_file.updated).tz(timezone).format('MM-DD-YYYY h:mm:ss a')
                        }
                        &nbsp;
                        {
                            props.downloadOnly === true
                            ? null
                            : (
                                !props.disabled
                                ?
                                <i
                                    onClick={props.onRemoveFile}
                                    id={assignment_file.id}
                                    className={`fa fa-times-circle red`}
                                />
                                : null
                            )
                        }
                    </div>
                    <div className="progress">
                        <div className="progress-bar progress-bar-striped bg-success"  style={{width:'100%'}} role="progressbar">Uploaded</div>
                    </div>
                </div>
            )
            : (
                <div key={prefix + assignment_file.id}>
                    {assignment_file.name}
                    <span className="progress">
                        {
                            assignment_file.progress === 0
                            ? (
                                <div
                                    key={prefix + assignment_file.id}
                                    className="bg-warning progress-bar progress-bar-animated progress-bar-striped"
                                    style={{width:'100%'}}
                                    role="progressbar"
                                >
                                    Uploading...
                                </div>
                            )
                            : (
                                assignment_file.progress === -1
                                ? (
                                    <div
                                        key={prefix + assignment_file.id}
                                        className="bg-danger progress-bar progress-bar-striped"
                                        style={{width:'100%'}}
                                        role="progressbar"
                                    >
                                        Error
                                    </div>
                                )
                                : (
                                    <div
                                        key={prefix + assignment_file.id}
                                        className="progress-bar"
                                        style={{width:'0%'}}
                                        role="progressbar"
                                    />
                                )
                            )
                        }
                    </span>
                </div>
            )
        );
    };

    return (
        <div className="card">
            <div className="card-block no-gutters message">
                <Dropzone className="dropzone row no-gutters"
                    onDrop={props.onDropAssignmentFile}
                    disableClick={true}
                    ref={(node) => { dropzone_ref = node; }}
                >
                    <b>{props.label}</b>
                    <div className="offset-sm-8 col-sm-4 mb-3">
                        {
                            props.downloadOnly === true
                            ?
                                null
                            :
                                <button
                                    type="button"
                                    onClick={() => { dropzone_ref.open(); }}
                                    className="btn btn-sm btn-primary float-right"
                                >
                                    Upload file <i className="fa fa-upload"/>
                                </button>
                        }
                    </div>
                    <div className="col-sm-12 loading-content">
                        {
                            _.map(
                                _.flatMap(
                                    props.assignment.assignment_files,
                                    assignment_file => {

                                        return assignment_file.name;
                                    }
                                ),
                                assignment_filename
                            )
                        }
                    </div>
                </Dropzone>
            </div>
        </div>
    );
};

AssignmentFileSubmission.propTypes = {
    downloadOnly: PropTypes.bool,
    onDropAssignmentFile: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    assignment: PropTypes.object,
    onDownloadFile: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default AssignmentFileSubmission;



/** WEBPACK FOOTER **
 ** ./src/components/AssignmentFileSubmission.js
 **/